export default {
  BROKER_EMIT: 'brokerEmit',
  BROKER_EMIT_SILENT: 'brokerEmitSilent',
  COMPLETE_MULTI_PART_UPLOAD: 'completeMultipartUpload',
  INIT_MULTIPART_UPLOAD: 'initMultipartUpload',
  MULTIPART_UPLOAD: 'multipartUpload',
  PUBLISH: 'publish',
  SUBSCRIBE: 'subscribe',
  TOGGLE_LOCAL_TRACK_MUTED: 'toggleLocalTrackMuted',
  UNPUBLISH: 'unpublish',
  UPLOAD_CHUNK: 'uploadChunk',
};
